<table class="table table-muted mb-0">
  <thead>
    <tr>
      <th>
        <a class="pointer" (click)="sort($event, 'location')">Location
          <i *ngIf="orderField === 'location' && order" class="fa"
            [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}">
          </i>
        </a>
      </th>
      <th *ngIf="!tender.company.settings.isHiddenField('location_company')">
        <a class="pointer" (click)="sort($event, 'companyInfo')">Company
          <i *ngIf="orderField === 'companyInfo' && order" class="fa"
            [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}">
          </i>
        </a>
      </th>
      <th *ngIf="!tender.company.settings.isHiddenField('location_fuel_type')">
        Fuel Type
      </th>
      <th *ngIf="!tender.company.settings.isHiddenField('location_flight_type')">
        Flight Type
      </th>
      <th *ngIf="!tender.company.settings.isHiddenField('location_delivery_point')">
        Delivery Point
      </th>
      <th>
        <a class="pointer" (click)="sort($event, 'volume')">Yearly Volume
          <i *ngIf="orderField === 'volume' && order" class="fa"
            [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}">
          </i>
        </a>
      </th>
      <th>
        Tags
      </th>
      <th>
        <a class="pointer" (click)="sort($event, 'supplier')">Supplier
          <i *ngIf="orderField === 'supplier' && order" class="fa"
            [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}">
          </i>
        </a>
      </th>
      <th>
        <a class="pointer" (click)="sort($event, 'award_self_supply')">Contract Type
          <i *ngIf="orderField === 'award_self_supply' && order" class="fa"
            [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}">
          </i>
        </a>
      </th>
      <th>
        <a class="pointer" (click)="sort($event, 'awarded_percent')">Awarded %
          <i *ngIf="orderField === 'awarded_percent' && order" class="fa"
            [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}">
          </i>
        </a>
      </th>
      <th>
        <a class="pointer" (click)="sort($event, 'awarded_volume')">Awarded Contract Vol.
          <i *ngIf="orderField === 'awarded_volume' && order" class="fa"
            [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}">
          </i>
        </a>
      </th>
      <th class="text-center">
        <a class="pointer" (click)="sort($event, 'status')">Status
          <i *ngIf="orderField === 'status' && order" class="fa"
            [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}">
          </i>
        </a>
      </th>
      <th class="text-center">
        <a class="pointer" (click)="sort($event, 'confirmed')">Confirmed
          <i *ngIf="orderField === 'confirmed' && order" class="fa"
            [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}">
          </i>
        </a>
      </th>
      <th>
        Settings
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor='let offer of offers'>
      <td>
        <div class="td d-flex align-items-center">
          <strong>{{ offer.contract.location.iata }}</strong>
        </div>
      </td>
      <td data-label="Company" *ngIf="!tender.company.settings.isHiddenField('location_company')">
        <span *ngIf="offer.contract.companyChild && offer.contract.companyChild?.name">{{
          offer.contract.companyChild?.getDisplayName() }}</span>
        <span *ngIf="!(offer.contract.companyChild && offer.contract.companyChild?.name)">{{ offer.contract.companyInfo
          }}</span>
      </td>
      <td data-label="Fuel Type" *ngIf="!tender.company.settings.isHiddenField('location_fuel_type')">
        <span *ngIf="offer.contract.fuelType?.name">{{tender.company.settings.getFilteredOptionLabel('fuel_type',
          offer.contract.fuelType)}}</span>
        <span *ngIf="!offer.contract.fuelType?.name" class="small text-muted">
          Not Provided
        </span>
      </td>
      <td data-label="Flight Type" *ngIf="!tender.company.settings.isHiddenField('location_flight_type')">
        <span *ngIf="offer.contract.flightType?.name">{{offer.contract.flightType.name}}</span>
      </td>
      <td data-label="Delivery Point" *ngIf="!tender.company.settings.isHiddenField('location_delivery_point')">
        <span *ngIf="offer.contract.fuelPreference?.name">{{offer.contract.fuelPreference.name}}</span>
      </td>
      <td data-label="Yearly Volume">
        {{ offer.contract.volume | number : '1.0-0' | usNumber }} {{ offer.unitsCode }}
      </td>
      <td data-label="Tags">
        <span *ngFor="let tag of offer.contract.tags">
          <span
            class="badge py-1 px-2 me-2 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill">
            {{tag['name']}}
          </span>
        </span>
      </td>
      <td data-label="Supplier">
        <div class="td d-flex align-items-center">
          <div *ngIf="offer.supplier.logo" class="avatar avatar-48 bg-white  me-3">
            <img class="p-2" src="{{ offer.supplier.logo }}" alt="{{ offer.supplier.name }}">
          </div>
          {{ offer.supplier.name }}
        </div>
      </td>
      <td data-label="Contract Type">
        <div>{{ offer.getAwardDisplay() }}</div>
      </td>
      <td data-label="Awarded %">
        <div>{{offer.awardedPercent}}%</div>
      </td>
      <td data-label="Awarded Contract Vol.">
        <div>{{ offer.awardedVolume | number : '1.0-0' | usNumber }} {{ offer.unitsCode }}</div>
      </td>
      <td data-label="Status" class="text-center">
        <jft-offer-status [status]="offer.status"></jft-offer-status>
      </td>
      <td data-label="Confirmed" class="text-center">
        <i *ngIf="offer.bid?.signature" class="bi bi-check-circle-fill text-success fs-5" title="Award confirmed by supplier"></i>
        <span *ngIf="!offer.bid?.signature" class="text-muted">-</span>
      </td>
      <td class="mobile-full">
        <ng-template #tipContent>
          <div class="text-start">
            <div *ngIf="offer.contract.dateStart">
              Contract start date: <strong>{{offer.contract.dateStart | date:'dd MMM yyyy':'UTC'}}</strong><br>
            </div>
            <div *ngIf="offer.contract.dateEnd">
              Contract end date: <strong>{{offer.contract.dateEnd | date:'dd MMM yyyy':'UTC'}}</strong><br>
            </div>
            <div *ngIf="offer.contract.currency?.code">
              Preferred currency: <strong>{{offer.contract.currency.code}}</strong><br>
            </div>
            <div *ngIf="offer.contract.units?.code">
              Preferred units: <strong>{{offer.contract.units.code}}</strong><br><br>
            </div>

            <div
              *ngIf="!tender.company.settings.isHiddenField('location_annual_frequency') && offer.contract.annualFrequency">
              Annual Frequency: <strong>{{offer.contract.annualFrequency}}</strong><br>
            </div>
            <div
              *ngIf="!tender.company.settings.isHiddenField('location_average_uplift') && offer.contract.averageUplift">
              Average uplift: <strong>{{offer.contract.averageUplift}}</strong><br>
            </div>
            <div
              *ngIf="!tender.company.settings.isHiddenField('location_months_of_service') && offer.contract.monthService">
              Months of service: <strong>{{offer.contract.monthService}}</strong><br>
            </div>
            <div
              *ngIf="!tender.company.settings.isHiddenField('location_monthly_volume') && offer.contract.monthService && offer.contract.volume">
              Monthly volume: <strong>{{offer.contract.volume / offer.contract.monthService | number : '1.0-0' |
                usNumber }} {{ offer.contract.units.code }}</strong><br>
            </div>
            <div *ngIf="!tender.company.settings.isHiddenField('location_award_quota') && offer.contract.awardQuota">
              Award quota: <strong>{{ offer.contract.awardQuota }}%</strong><br>
            </div>
            <div *ngIf="!tender.company.settings.isHiddenField('location_branded')">
              Branded: <strong>{{ offer.contract.branded ? 'Yes' : 'No' }}</strong><br>
            </div>

            <div *ngIf="!tender.company.settings.isHiddenField('location_notes') && offer.contract.notes">
              <br>
              Location Specific Notes:<br>{{offer.contract.notes}}<br>
            </div>
          </div>
        </ng-template>
        <a href="javascript:void(0);" placement="left" [ngbTooltip]="tipContent">
          <i class="fas fa-sliders-h"></i>
        </a>
      </td>
    </tr>

    <!-- Empty state -->
    <tr *ngIf="!offers.length && !loading" class="mobile-plain">
      <td colspan="10">
        <p class="text-center small my-5">No offers to display</p>
      </td>
    </tr>

    <!-- Loading placeholders -->
    <tr *ngIf="loading" class="placeholder-glow mobile-plain">
      <td><span class="placeholder col-2"></span></td>
      <td><span class="placeholder col-8"></span></td>
      <td><span class="placeholder col-6"></span></td>
      <td><span class="placeholder col-5"></span></td>
      <td><span class="placeholder col-7"></span></td>
      <td><span class="placeholder col-4"></span></td>
      <td><span class="placeholder col-6"></span></td>
      <td><span class="placeholder col-5"></span></td>
      <td><span class="placeholder col-3"></span></td>
      <td><span class="placeholder col-4"></span></td>
    </tr>
    <tr *ngIf="loading" class="placeholder-glow mobile-plain">
      <td><span class="placeholder col-2"></span></td>
      <td><span class="placeholder col-7"></span></td>
      <td><span class="placeholder col-5"></span></td>
      <td><span class="placeholder col-6"></span></td>
      <td><span class="placeholder col-8"></span></td>
      <td><span class="placeholder col-4"></span></td>
      <td><span class="placeholder col-5"></span></td>
      <td><span class="placeholder col-6"></span></td>
      <td><span class="placeholder col-3"></span></td>
      <td><span class="placeholder col-4"></span></td>
    </tr>
    <tr *ngIf="loading" class="placeholder-glow mobile-plain">
      <td><span class="placeholder col-2"></span></td>
      <td><span class="placeholder col-9"></span></td>
      <td><span class="placeholder col-4"></span></td>
      <td><span class="placeholder col-7"></span></td>
      <td><span class="placeholder col-6"></span></td>
      <td><span class="placeholder col-4"></span></td>
      <td><span class="placeholder col-7"></span></td>
      <td><span class="placeholder col-5"></span></td>
      <td><span class="placeholder col-3"></span></td>
      <td><span class="placeholder col-4"></span></td>
    </tr>
  </tbody>
</table>
